<app-nav-menu *ngIf="showLayout()"></app-nav-menu>
<router-outlet></router-outlet>
<app-footer *ngIf="showLayout()"></app-footer>